import { render, staticRenderFns } from "./viewAll.vue?vue&type=template&id=857f7424&scoped=true&"
var script = {}
import style0 from "./viewAll.vue?vue&type=style&index=0&id=857f7424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857f7424",
  null
  
)

export default component.exports